import { LinearProgress, Typography } from "@material-ui/core";
import React, { FC, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getExams } from "../../api/ExamApi";
import { NewEntityId } from "../../data/constants";
import { ExamTemplateIndex } from "../../model/Exam";
import { routesPaths } from "../../Routes";
import { navigateTo } from "../../utils/Navigation";
import TranslatedMessage from "../translations/TranslatedMessage";
import ExamGrid from "./ExamGrid";

const ExamList: FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [exams, setExams] = useState<ExamTemplateIndex[]>([]);
  const history = useHistory();

  useEffect(() => {
    getExams().then((result) => {
      setExams(result);
      setIsLoading(false);
    });
  }, []);

  if (isLoading) {
    return <LinearProgress variant="query" />;
  }

  const navigateToExam = (examId: string) => navigateTo(routesPaths.exam(examId), history);

  return (
    <>
      <Typography variant="h5">
        <TranslatedMessage id="exam.header" />
      </Typography>
      <ExamGrid
        exams={exams}
        onRowClick={(row: ExamTemplateIndex) => navigateToExam(row.id)}
        onAddClick={() => navigateToExam(NewEntityId)}
      />
    </>
  );
};

export default ExamList;
